import React, { useState, useEffect } from 'react';
import { createIncident } from '../../api';

// Updated modal to work with the parent container providing the overlay
const ModalIncidencias = ({ onClose, shipmentReference = '' }) => {
  const [description, setDescription] = useState('');
  const [user, setUser] = useState('');
  const [shipmentRef, setShipmentRef] = useState(shipmentReference);
  const [incidentType, setIncidentType] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const userName = localStorage.getItem('userName');
    if (userName) {
      setUser(userName);
    }
    
    if (shipmentReference) {
      setShipmentRef(shipmentReference);
    }
  }, [shipmentReference]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await createIncident({ 
        description, 
        user, 
        shipmentReference: shipmentRef, 
        incidentType 
      });
      alert('Incidencia registrada exitosamente');
      onClose();
    } catch (error) {
      console.error('Error al registrar incidencia:', error);
      alert('Error al registrar la incidencia');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-lg mx-4">
      <h2 className="text-2xl md:text-3xl font-semibold mb-6 text-center text-gray-800">Registrar Incidencia</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Referencia del Viaje</label>
          <input
            type="text"
            value={shipmentRef}
            onChange={(e) => setShipmentRef(e.target.value)}
            className="mt-1 block w-full p-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Tipo de Incidencia</label>
          <select
            value={incidentType}
            onChange={(e) => setIncidentType(e.target.value)}
            className="mt-1 block w-full p-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          >
            <option value="">Seleccione un tipo de incidencia</option>
            <option value="Falla Mecanica">Falla Mecanica</option>
            <option value="Llanta Ponchada/ Explotada">Llanta Ponchada/ Explotada</option>
            <option value="Accidente">Accidente</option>
            <option value="Desvio">Ruta no Autorizada</option>
            <option value="Robo">Robo</option>
            <option value="GPS">Sin visualizacion Gps</option>
          </select>
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Descripción</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="mt-1 block w-full p-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            rows="4"
            required
            placeholder="Describa la incidencia ocurrida..."
          />
        </div>
        <div className="flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="mr-2 px-4 py-2 bg-gray-300 rounded-md hover:bg-gray-400 transition-colors duration-200"
          >
            Cancelar
          </button>
          <button
            type="submit"
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors duration-200"
            disabled={loading}
          >
            {loading ? 'Registrando...' : 'Registrar'}
          </button>
        </div>
      </form>
      <div className="mt-4 text-sm text-gray-500">
        <p>Registrado por: <span className="font-medium text-gray-700">{user}</span></p>
      </div>
    </div>
  );
};

export default ModalIncidencias;
